import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { CategoryResponse } from '../../responses/platform/category.response';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getCategory(): Observable<CategoryResponse> {
    return this.http
      .get<CategoryResponse>(environment.urlApiPlatform + "Category", this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
